import * as React from 'react';
import styled, { DefaultTheme, CSSObject } from 'styled-components';

import * as T from '../../serviceTheme';
import { LabelStyle } from './FormStyle';
import { makeSlot } from './slots';

export type LabelLocation = 'top' | 'left';

type PropsForLabel = { theme: DefaultTheme } & {
    isRequired: boolean,
    labelLocation: LabelLocation,
} & Pick<LabelStyle, 'labelHeight'>;

const labelRequired = (theme: DefaultTheme, isReq: boolean): CSSObject => {
    if(isReq){
        return {
            '&: after': {
                content: "' *'",
                color: T.safeGetPrimary({ theme }),
            }
        }
    }
    else {
        return {}
    }
}

const labelLocated = (theme: DefaultTheme, location: LabelLocation, labelHeight: number): CSSObject => {
    switch(location){
        case 'left': {
            return {
                justifyContent: 'flex-end',
                height: `${labelHeight}px`,
                lineHeight: `${labelHeight}px`,
                fontFamily: T.bold({ theme }),
            }
        }
        case 'top': {
            return {
                paddingBottom: '5px',
                justifyContent: 'flex-start',
                fontFamily: T.regular({ theme }),
            }
        }
    }
}

const getAfterLabel = ({ isRequired, theme, labelLocation, labelHeight }: PropsForLabel): CSSObject => 
    ({ 
        ...labelRequired(theme, isRequired), 
        ...labelLocated(theme, labelLocation, labelHeight),
    });


const LabelS = styled.div<PropsForLabel>`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    grid-area: label;
    color: initial;
    display: flex;
    align-items: baseline;

    ${getAfterLabel}
`;


export const Label = makeSlot('label')(({ 
    children, 
    isRequired, 
    labelLocation, 
    labelHeight,
    onClick,
    className,
}) => {

    return (
        <LabelS
            className={className}
            isRequired={isRequired}
            labelLocation={labelLocation}
            labelHeight={labelHeight}
            onClick={onClick}>
            {children}
        </LabelS>
    );
});